import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { contact, services } from '../data/site';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-ink-700 bg-ink-900">
      <div className="container-site grid gap-12 py-16 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
            Electronics, IoT, AI and software consulting based in Moncton, New Brunswick, helping businesses across
            Atlantic Canada turn ideas into working products.
          </p>
        </div>

        <div className="md:col-span-4">
          <h2 className="eyebrow">Services</h2>
          <ul className="mt-5 space-y-3 text-sm">
            {services.map((service) => (
              <li key={service.id}>
                <Link to={`/services#${service.id}`} className="text-slate-400 transition hover:text-white">
                  {service.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h2 className="eyebrow">Contact</h2>
          <ul className="mt-5 space-y-3 text-sm">
            <li>
              <a href={`mailto:${contact.email}`} className="text-slate-400 transition hover:text-white">
                {contact.email}
              </a>
            </li>
            <li>
              <a href={contact.phoneHref} className="text-slate-400 transition hover:text-white">
                {contact.phone}
              </a>
            </li>
            <li className="text-slate-400">{contact.location}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-ink-700">
        <div className="container-site flex flex-col gap-2 py-6 text-xs text-slate-500 sm:flex-row sm:justify-between">
          <p>© {year} Gomagen Holdings Ltd. All rights reserved.</p>
          <p className="font-mono">Electronics · IoT · AI · Software</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
